import styled from 'styled-components';

export const ChecklistContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  margin: 24px 0px;
`;

export const ChecklistTitle = styled.p`
  font-family: Inter;
  font-weight: 500;
  font-style: Italic;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0px;
  vertical-align: middle;
  color: #f8fafc;
`;

export const ChecklistList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ChecklistItem = styled.li`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: Inter;
  font-weight: 400;
  font-style: Regular;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 150%;
  letter-spacing: 0px;
  vertical-align: middle;
  color: #f8fafc;

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

export const CheckmarkWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 2px;
`;
